import { useState, useEffect } from 'react';
import { projectsData } from '../assets/data';
import ProjectCard from './ProjectCard';

const Gallery = () => {
  const [activeCategory] = useState('all');
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({
        x: (e.clientX / window.innerWidth) * 100,
        y: (e.clientY / window.innerHeight) * 100,
      });
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  const filteredProjects = activeCategory === 'all'
    ? projectsData
    : projectsData.filter(project => project.category === activeCategory);

  return (
    <section className="py-24 min-h-screen relative overflow-hidden bg-white">
      {/* Vague décorative en haut */}
      <div className="absolute top-0 left-0 w-full h-24 pointer-events-none select-none z-0">
        <svg viewBox="0 0 1200 120" className="w-full h-full">
          <path d="M0,0V7.23C0,65.52,268.63,112.77,600,112.77S1200,65.52,1200,7.23V0Z" className="fill-amber-100" />
          <path d="M0,0V15.81C0,72.92,268.63,118.27,600,118.27S1200,72.92,1200,15.81V0Z" className="fill-orange-100" />
        </svg>
      </div>
      {/* Animation de fond façon Projects.jsx */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
        {[...Array(30)].map((_, i) => (
          <div
            key={i}
            className="absolute w-1 h-1 bg-gradient-to-r from-amber-400 to-orange-500 rounded-full opacity-20 animate-pulse"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${i * 0.2}s`,
              transform: `translate(${mousePosition.x * 0.01}px, ${mousePosition.y * 0.005}px)`
            }}
          />
        ))}
      </div>
      <div className="container mx-auto px-5 relative z-10">
        <div className="text-center mb-20 relative">
          <h2 className="text-3xl md:text-4xl font-bold mb-5 text-dark relative">
            Nos Réalisations
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto leading-relaxed">
            Découvrez nos projets de décoration intérieure et extérieure
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProjects.map((project, index) => (
            <ProjectCard
              key={project.id}
              project={project}
              index={index}
            />
          ))}
        </div>
      </div>
      {/* Vague décorative en bas */}
      <div className="absolute bottom-0 left-0 w-full h-24 pointer-events-none select-none z-0">
        <svg viewBox="0 0 1200 120" className="w-full h-full">
          <path d="M0,0V7.23C0,65.52,268.63,112.77,600,112.77S1200,65.52,1200,7.23V0Z" className="fill-amber-100" />
          <path d="M0,0V15.81C0,72.92,268.63,118.27,600,118.27S1200,72.92,1200,15.81V0Z" className="fill-orange-100" />
        </svg>
      </div>
    </section>
  );
};

export default Gallery;